import { useCallback, useEffect, useRef } from 'react'

/**
 * Attaches to a textarea ref and auto-resizes its height whenever `value` changes.
 * Returns both the ref and an imperative `resize()` function for use in onChange handlers.
 */
export function useAutoResizeTextarea(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null)

  const resize = useCallback(() => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
  }, [])

  useEffect(() => {
    resize()
  }, [value, resize])

  return { ref, resize }
}
